import { Stack, Typography } from '@mui/material';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton.tsx';
import { FSSecondaryButton } from '@/ui/components/button/FSSecondaryButton.tsx';
import { FSModal } from '@/ui/components/modal/FSModal';
import { FSModalTitle } from '@/ui/components/modal/FSModalTitle';
import { translate } from '@/ui/i18n';

export function ModalPresetJaugeValid({
  open,
  onClose,
  onValid,
}: {
  open: boolean;
  onClose: () => void;
  onValid: () => void;
}) {
  const handleValid = () => {
    onClose();
    onValid();
  };
  return (
    <FSModal open={open} onClose={onClose} showCloseButton={true}>
      <Stack spacing={3}>
        <FSModalTitle
          title={translate('ProjectsVenue.alert-preset-jauge-change-title')}
        />
        <Typography>
          {translate('ProjectsVenue.alert-preset-jauge-change-description')}
        </Typography>
        <Stack
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-end"
          gap={1}
        >
          <FSSecondaryButton onClick={onClose}>
            {translate('ProjectsVenue.cancel')}
          </FSSecondaryButton>
          <FSPrimaryButton onClick={handleValid}>
            {translate('ProjectsVenue.edit-jauge')}
          </FSPrimaryButton>
        </Stack>
      </Stack>
    </FSModal>
  );
}
